import { render, staticRenderFns } from "./OEko.vue?vue&type=template&id=5843fa8a"
import script from "./OEko.vue?vue&type=script&lang=js"
export * from "./OEko.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports